import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "companies",
    object: "company",
    selected_id: null,
    header: [
      { text: "ID", value: "id" },
      { text: "Name", value: "name" },
      { text: "Picture", value: "picture" },
      { text: "Regions", value: "regions" },
      { text: "Membership", value: "member_actions" },
      { text: "Products", value: "products" },
      { text: "Actions", value: "actions", sortable: false }
    ]
  },
  mutations: {
    ...genericStore.mutations,
    add_items(state, data) {
      state.selected_id = data ? data : null;
    }
  },
  actions: {
    ...genericStore.actions,
    selectItem({ commit }, item) {
      commit("add_items", item);
    }
  },
  getters: {
    ...genericStore.getters
  }
};
